const messages = {
  title: "Produktinformasjon og godkjenninger",
  description:
    "Velkommen til brosjyre- og prislisteområdet for Bridgestone- og Firestone-produkter. Her finner du nåværende brosjyrer og prislister for alle produktområder og Pricat-filer for lagerstyringen din.",
};
export default {
  messages,
};
